import Lenis from 'lenis';
import MainHeader from './components/MainHeader';
import MainFooter from './components/MainFooter';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.initLenis();
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
	}

	initLenis() {
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

		window.lenis = new Lenis({
			autoRaf: true,
			syncTouch: false,
		});
	}

	init() {
		this.initLogoMarquees();
		MainHeader.init();
		MainFooter.init();
	}

	initLogoMarquees() {
		const marquees = document.querySelectorAll<HTMLElement>('.block-logos-marquee');

		if (!marquees.length || !('IntersectionObserver' in window)) {
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					entry.target.classList.toggle('is-scroll-active', entry.isIntersecting);
				});
			},
			{ rootMargin: '300px 0px' }
		);

		marquees.forEach((marquee) => {
			marquee.classList.add('is-marquee-managed');
			observer.observe(marquee);
		});
	}

	resized() {
		MainHeader.resized();
		MainFooter.resized();
	}

	loaded() {
		MainHeader.loaded();
	}
}

// Run controller.
new Controller();
